import * as React from 'react';
import { css, StyleSheet } from 'aphrodite/no-important';
import { Link } from '../../partials/link/Link';

interface AuthorProps {
  name: string;
  link?: string;
  prefix?: string;
  color: string;
}

const getStyle = (color: string) => StyleSheet.create({
  author: {
    color,
  },
});

export const Author: React.FunctionComponent<AuthorProps> = props => {
  const { name, link, color, prefix = '' } = props;
  const style = getStyle(color);

  if (link) {
    return (
      <React.Fragment>
        {prefix}
        <Link href={link} className={css(style.author)}>{name}</Link>
      </React.Fragment>
    );
  }

  return <React.Fragment>{`${prefix}${name}`}</React.Fragment>;
};
